import * as React from 'react';

export interface Keys {
  tmxOrgId: string;
  appInsightsConnectionString: string;
  oneDSAppInsightsInstrumentationKey: string;
}

export const emptyKeys: Keys = {
  tmxOrgId: '',
  appInsightsConnectionString: '',
  oneDSAppInsightsInstrumentationKey: '',
};

const KeyStore = React.createContext<Keys>(emptyKeys);

export const KeyProvider = KeyStore.Provider;

export function useKeyStore() {
  return React.useContext(KeyStore);
}
